var _path, _path2, _path3, _path4, _path5, _path6, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckDotted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.493C18.3474 23.493 23.493 18.3474 23.493 12C23.493 5.65261 18.3474 0.507042 12 0.507042C5.65261 0.507042 0.507042 5.65261 0.507042 12C0.507042 18.3474 5.65261 23.493 12 23.493ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#3360AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6668 11.9997C23.6668 18.443 18.4435 23.6663 12.0002 23.6663C5.55684 23.6663 0.333496 18.443 0.333496 11.9997C0.333496 5.55635 5.55684 0.333008 12.0002 0.333008C18.4435 0.333008 23.6668 5.55635 23.6668 11.9997Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10345 12.2834C8.10345 13.2089 7.32532 13.9593 6.36544 13.9593C5.40557 13.9593 4.62744 13.2089 4.62744 12.2834C4.62744 11.3578 5.40557 10.6074 6.36544 10.6074C7.32532 10.6074 8.10345 11.3578 8.10345 12.2834Z",
    fill: "#F28520"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.082 14.6381C11.7607 15.3169 11.7804 16.3976 11.1259 17.0521C10.4714 17.7066 9.3906 17.687 8.71186 17.0083C8.03313 16.3295 8.01348 15.2487 8.66797 14.5942C9.32246 13.9397 10.4033 13.9594 11.082 14.6381Z",
    fill: "#3360AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1043 7.61577C18.7831 8.2945 18.7831 9.39495 18.1043 10.0737C17.4256 10.7524 16.3252 10.7524 15.6464 10.0737C14.9677 9.39495 14.9677 8.29451 15.6464 7.61577C16.3252 6.93704 17.4256 6.93704 18.1043 7.61577Z",
    fill: "#208C72"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5936 11.1265C15.2723 11.8052 15.2723 12.9057 14.5936 13.5844C13.9149 14.2632 12.8144 14.2632 12.1357 13.5844C11.457 12.9057 11.457 11.8052 12.1357 11.1265C12.8144 10.4478 13.9149 10.4478 14.5936 11.1265Z",
    fill: "#EA1763"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#3360AD",
    strokeWidth: 2,
    fill: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDotted);
export default __webpack_public_path__ + "static/media/check-dotted.9e2f036ed46bb545e25cb4b9034b0fff.svg";
export { ForwardRef as ReactComponent };